import React from "react";
import Cx from "classnames";

import styles from "./styles.scss";
import { activatePopup } from "../helpers.js";
import { instantSave } from "../../../helpers.js";

export default class extends React.Component {
  popup = () => {
    const items = this.props.items;
    const index = items.findIndex((i) => i.isPrimary);
    activatePopup(items, index);
  };

  componentDidUpdate(prevProps, prevState) {
    const prevId = prevProps.item ? prevProps.item.id : null;
    const currentId = this.props.item ? this.props.item.id : null;

    if (prevId !== currentId) instantSave();
  }

  render() {
    const { recordType } = this.props;
    const image = this.props.item;
    const processed = image ? image.status === "processed" : false;

    return (
      <div className={Cx("panel", image ? null : "closed")}>
        <div className="panel-title">Primary Image</div>
        {processed && (
          <div className={styles.imgArea} onClick={this.popup}>
            <img src={image.medium} />
          </div>
        )}
        <input
          className="primary_image"
          name={`${recordType}[primary_image]`}
          id={`${recordType}_primary_image`}
          type="hidden"
          value={image ? image.id : ""}
        />
      </div>
    );
  }
}
